(function () {
  var root = document.querySelector('[data-sw-root]');
  if (!root) return;

  var tabs = [].slice.call(root.querySelectorAll('[data-sw-tab]'));
  var panels = [].slice.call(root.querySelectorAll('[data-sw-panel]'));
  var crumbEl = root.querySelector('[data-sw-crumb]');
  var keys = tabs.map(function (t) { return t.getAttribute('data-sw-tab'); });
  var defaultKey = root.getAttribute('data-sw-default') || keys[0];

  function getT() {
    try {
      var t = new URLSearchParams(location.search).get('t');
      if (t && keys.indexOf(t) !== -1) return t;
    } catch (e) {}
    return defaultKey;
  }

  function show(key, push) {
    if (keys.indexOf(key) === -1) key = defaultKey;
    panels.forEach(function (p) { p.hidden = p.getAttribute('data-sw-panel') !== key; });
    tabs.forEach(function (t) {
      var on = t.getAttribute('data-sw-tab') === key;
      t.classList.toggle('is-active', on);
      if (on && crumbEl) {
        var c = t.getAttribute('data-sw-crumb-text');
        if (c) crumbEl.textContent = c;
      }
    });
    if (push) {
      try {
        var url = key === defaultKey ? location.pathname : location.pathname + '?t=' + key;
        history.replaceState(null, '', url);
      } catch (e) {}
    }
  }

  tabs.forEach(function (t) {
    t.addEventListener('click', function (e) {
      e.preventDefault();
      show(t.getAttribute('data-sw-tab'), true);
    });
  });

  show(getT(), false);
})();
